<template>
<viewer452 />
</template>

<script>
import Viewer452 from "@/views/boards/single-page/452/Viewer.vue";

export default {
  components: {Viewer452}

}
</script>

<style scoped>

</style>
